<template functional>
  <div :class="`page ${props.customClass} `" :style="props.customStyle">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    customStyle: {
      type: Object,
      default: () => {}
    },
    customClass: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  position: relative;
  box-sizing: border-box;

  height: 100%;
}

.page-wrapper {
  display: flex;

  height: 100vh;

  flex-direction: column;
}

@supports (bottom: constant(safe-area-inset-bottom)) or
  (bottom: env(safe-area-inset-bottom)) {
  .page {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}
</style>
